// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/GothamNarrow-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/GothamNarrow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/GothamNarrow-Medium.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/GothamNarrow-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/GothamNarrow-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/GothamNarrow-Light.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#GothamNarrow-Medium" });
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "#GothamNarrow-Light" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@font-face {
  font-family: 'Gotham Narrow';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('svg');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Gotham Narrow';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff2'),
      url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff'),
      url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('svg');
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

.addAssetButton {
  background-color: rgba(75, 75, 75, 1) !important;
  border-color: rgba(75, 75, 75, 1) !important;
}

.addAssetButton:hover {
  /*background-color: rgba(41, 241, 195, 1) !important;*/
  background-color: rgba(0, 76, 102, 1) !important;
  /*border-color: rgba(41, 241, 195, 1) !important;*/
  border-color: rgba(0, 76, 102, 1) !important;
}

.addFormPlusIcon:hover {
  /*color: rgba(41, 241, 195, 1) !important;*/
  color: rgba(0, 76, 102, 1) !important;
}

.addHardwareFormOuterWrapper {
  height: 520px;
  overflow: scroll;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.modal-content {
  background-color: var(--mantine-color-default) !important;
  color: var(--mantine-color-text);
}

.modal-button-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 200px;
  margin-top: 20px;
}

.mantine-Modal-inner {
  color: var(--mantine-color-text);
}

.mantine-Drawer-content {
  color: var(--mantine-color-text);
}

.acceptedSolutionWrapper {
  background-color: rgba(41, 241, 195, 0.10);
  margin-top: 20px;
}

.accordianToggle {
  cursor: pointer;
}

#activeForumHeader {
  /*background-color: rgba(41, 241, 195, 1);*/
  background-color: rgba(0, 76, 102, 1);
  color: white;
}

#activeSideNavLink{
  color: black;
  font-weight: bold;
}

.activeSideNavLinkBox {
  /*background-color: rgba(41, 241, 195, 1);*/
  background-color: rgba(0, 76, 102, 1);
}

.activeMyAssignedTicketsHeader {
  /* color: #38d9a9; */
  color: #228be6;
}

.adminDashboardUserSearchBar {
  width: 380px !important;
}

.adminDashboardUserSearchBar:hover {
  background-color: rgba(0, 76, 102, 0.25) !important;
}

.adminDashboardHardwareAssetSearchBar {
  width: 310px !important;
}

.adminDashboardHardwareAssetSearchBar:hover {
  background-color: rgba(0, 76, 102, 0.25) !important;
}

.adminDashboardSoftwareAssetSearchBar {
  width: 355px !important;
}

.adminDashboardSoftwareAssetSearchBar:hover {
  background-color: rgba(0, 76, 102, 0.25) !important;
}

.addSoftwareAssignmentButtonContainer {
  position: absolute;
  left: 0;
  padding-left: 10px;
}

.affectedDevicesDrawer {
  offset: 8px !important;
}

.affectedDevicesHoverCardBackground {
  /* background-color: var(--mantine-color-dark-4) !important; */
  background-color: var(--mantine-color-default) !important;
}

.affectedDevicesHoverCardText {
  color: var(--mantine-color-text) !important;
  /* color: var(--mantine-color-gray-4) !important; */
  cursor: default;
}

.assetFilterResetButtonContainer {
  position: absolute;
  left: 0;
  padding-left: 10px;
}

#assetAssignmentsButton {
  position: absolute;
  top: 15%;
  left: 15px;
}

body {
  background-color: #00000000 !important;
}

.cardHeader {
  background-color: #12344d !important;
}

.clarifyFormButtonContainer {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

/* #clarifyFormReassignmentSelectorWrapper{
  display: inline-block;
  padding-top: 0px;
} */

.col-centered{
  float: none;
  margin: 0 auto;
}

.commentReplyingToTableRow {
  border-top: none !important;
}

.commentReplyingToWrapper {
  background-color: rgba(240, 248, 255, 1);
}

#downVotesText {
  color: red;
}

.defaultCursor {
  cursor: default;
}

.gothamNarrowFont {
  font-family: 'Gotham Narrow';
  font-weight: 500;
  font-style: normal;
}

.gothamNarrowLightFont {
  font-family: 'Gotham Narrow';
  font-weight: 300;
  font-style: normal;
}

.hardwareAssetFilterIcon:hover {
  /*color: rgba(41, 241, 195, 1) !important;*/
  color: rgba(0, 76, 102, 1) !important;
}

/* .hardwareAssetTableRow:hover {
  background-color: pink !important;
} */

.hardwareAssetTable tbody tr:hover td {
  background-color: rgba(0, 76, 102, 1);
}

.reportTable tbody tr:hover td {
  background-color: rgba(0, 76, 102, 1);
  color: white;
  cursor: pointer;
}

#hardwareAssetEditDetailsButton {
  position: absolute;
  top: 15%;
  right: 15px;
  width: 110px;
}

.knowledgebaseButton:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.landingPageInfoCard {
  border: none !important;
  /* background-color: whitesmoke !important; */
  background-color: rgba(211,211,211, 1) !important;
}

#landingPageLoginButton {
  color: black !important;
  font-size: 15pt;
}

#landingPageLoginButtonContainer {
  position: absolute;
  top: 0px;
  right: 0px;
  padding-top: 25px;
  padding-right: 45px;
}

#landingPageWelcomeMessage {
  position: absolute;
  float: left;
  left: 0px;
  top: 0px;
  color: white;
  font-family: 'Gotham Narrow';
  font-style: normal;
  font-weight: 500;
  padding-top: 25px;
  padding-left: 15px;
}

/* #logoWhiteCircle {
  border-radius: 50%;
  width: 38px;
  height: 38px;
  background-color: white;
} */

.myTicketTableText {
  text-align: left;
}

.myTicketTableRow:hover {
  /* background-color: rgba(0, 76, 102, 1); */
  background-color: rgba(52, 92, 124, 1);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  /*color:rgba(41, 241, 195, 1);*/
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.popular-activities-table-row:hover {
  background-color: rgba(52, 92, 124, 1);
  /* background-color: rgba(0, 76, 102, 1); */
  box-shadow: 0 4px 28px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.popular-activities-link-text {
  color: rgba(75, 75, 75, 1);
}

.popular-activities-link-text:hover {
  /*color: rgba(41, 241, 195, 1);*/
  color: white;
  font-weight: bold;
  text-decoration: none;
}

.replyButtonTableRow {
  border-top-style: none !important;
}

.requiredStar {
  color:red;
  padding-left: 2px;
}

.miniKnowledgebaseWrapper {
  background-color: #edeef3;
  position: absolute;
  right: 30px;
  width: 325px;
  /* height: 83vh;
  overflow-y: scroll; */
}

.miniKnowledgebase {
  /* background-color: darkred; */
  /* position: relative; */
  margin-left: auto;
}

.miniKnowledgebaseIssuePreview {
  color:gray;
  font-size: 10pt !important;
}

.miniKnowledgebaseTable {
  max-width: 100%;
  max-height: 100%;
}

td .removeAssignmentButtonWrapper {
  position: absolute;
  right: 0;
  margin-right: 30px;
  opacity: 0;
  transition: opacity .2s ease-out; /* adding transition, improved UI */
  cursor: pointer;                  /* change cursor when hovering icon */
  transition-delay: .1s;
}

td:hover .removeAssignmentButtonWrapper {
  position: absolute;
  right: 0;
  margin-right: 30px;
  opacity: 1;
  transition-delay: 0s;
  /* padding-right: 30px; */
}

.mantine-DateInput-calendarHeader {
  color: var(--mantine-color-text)
}

.mantine-DateTimePicker-calendarHeader {
  color: var(--mantine-color-text)
}

.mantine-DatePickerInput-calendarHeader {
  color: var(--mantine-color-text)
}

.mantine-Select-dropdown {
  position: relative;
  z-index: 5000;
}

.mantineBlue {
  color: var(--mantine-color-blue-text);
  font-size: var(--mantine-font-size-sm);
}

/* Used in the user profile permissions table */
.roleYesText {
  color: var(--mantine-color-blue-8)
}

/* Used in the user profile permissions table */
.roleNoText {
  color: var(--mantine-color-red-8)
}

#serverRoomImageContainer {
  max-width: 100%;
  position: relative;
}

.scrollTableWrapper{
  height: 500px;
  overflow: scroll;
}

.scrollTableWrapperAssignedTickets{
  height: 451px;
  overflow-y: scroll;
}

.scrollTableWrapperTechNotes{
  max-height: 260px;
  overflow: scroll;
}

/* #selectAssignedTechDropdownButton{
  color: pink;
} */

.selectAssignedTechDropdownTriangleIcon{
  padding-left: 3px;
  font-size: 13px;
}

.smallCumulusLogoContainer {
  position: absolute;
  top: 125px;
  padding-right: 150px;
  margin-left: 300px;
  /* background-color: aqua; */
  /* padding-top: 25px;
  padding-right: 45px; */
}

.suggestedPostsTitle {
  text-align: center;
}

/* .sidebarContainer {
  margin: 40px 0 0 0;
  padding: 0;
  width: 200px;
  background-color: #343a40;
  position: fixed;
  height: 100%;
  overflow: auto; /*affects whether there's a scroll bar or not may need "scroll" here*/
/*}

/* Sidebar link first item */
/* .sidebarNav:first-child {
  padding-top: 0px;
} */

/* Sidebar links */
/* .sideNavItem {
  display: block;
  color: black;
  padding: 5px;
  text-decoration: none;
} */

/* Sidebar link (text part) - override the Link class */
/* .sideNavLink {
  color: rgba(255,255,255,.5);
}

.sideNavLink:hover {
  color: rgba(41, 241, 195, 1);
} */

.ticketLandingCard {
  color: rgba(75, 75, 75, 1);
}

.ticketLandingCard:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  color: rgba(203, 51, 59, 1);
}

.ticketLandingLink:hover {
  text-decoration: none;
}

/*.ticketTableBody > tr:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  cursor: pointer;
  background-color: rgba(41, 241, 195, 0.2);
  
}*/

.techNoteTableHead > th {
  background-color: rgba(75, 75, 75, 1);
  color: white;
}

.techNoteTableHead >th:hover {
  cursor: default;
}

.ticketTableHead > th {
  background-color: rgba(75, 75, 75, 1);
  color: white;
}

.ticketTableHead > th:hover {
  /*background-color:rgba(41, 241, 195, 1);*/
  background-color: rgba(0, 76, 102, 1);
  color: white;
  cursor: pointer;
}

#reactQuillBoxDisabled {
  cursor: default !important;
  background-color: lightgray !important;
}

#createTicketIssueText {
  background-color: white !important;
}

.ql-editor{
  min-height: 120px;
  font-size: 15px;
}

.reportTableHead > th {
  background-color: rgba(75, 75, 75, 1);
  color: white;
  cursor: default;
}

.submitterDetailsIcon {
  color: var(--mantine-color-blue-8);
}

.ticketTableHeadNoHover:hover {
  background-color: rgba(75, 75, 75, 1) !important;
  color: white !important;
  cursor: default !important;
}

.ticketCategoryName {
  /* color:rgba(68, 108, 179, 1); */
  color: rgba(75, 75, 75, 1);
}

.ticketTitleText {
  font-size: 20px;
  /* color: rgba(75, 75, 75, 1); */
  /* text-decoration: underline; */
}

/* .ticketTitleText:hover {
  color:rgba(41, 241, 195, 1);
} */

.ticketIssuePreview {
  color:gray;
}

.topNavbarLink {
  color: var(--mantine-color-text) !important;
  line-height: 66px;
}

.topNavbarLink:hover {
  /*color:rgba(41, 241, 195, 1) !important;*/
  /* color: rgba(0, 76, 102, 1) !important; */
  color: rgba(52, 92, 124, 1) !important;
  cursor: pointer;
}

#ticketForumPageHeader {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 30px;
}

#ticketDateText {
  font-size: 13px;
  text-align: left;
}

#ticketRequesterText {
  font-size: 13px;
}

#ticketViews {
  text-align: left;
}

#thumbImage {
  height: 15px;
  width: 15px;
}

#upVotesText {
  color: green;
}

.wholeCard {
  border-radius: 50px !important;
}

.nav-tabs .nav-link {
  color: white;
}

.nav-tabs .nav-link:hover {
  /*color: rgba(41, 241, 195, 1);*/
  /* color: rgba(0, 76, 102, 1); */
  color: rgba(52, 92, 124, 1);
  /*border: 1px solid rgba(41, 241, 195, 1) !important;*/
  /* border: 1px solid rgba(0, 76, 102, 1) !important; */
  border: 1px solid rgba(52, 92, 124, 1) !important;
}

.nav-tabs .nav-link.active {
  /*background-color: rgba(41, 241, 195, 1) !important;*/
  /* background-color: rgba(0, 76, 102, 1) !important; */
  background-color: rgba(52, 92, 124, 1) !important;
  /*border: 1px solid rgba(41, 241, 195, 1) !important;*/
  /* border: 1px solid rgba(0, 76, 102, 1) !important; */
  border: 1px solid rgba(52, 92, 124, 1) !important;
  font-weight: bold;
  color: white !important;
}

.emailDisableHardwareSwitch {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  left: 500px;
  margin-top: 100px;
  margin-bottom: 20px;
  padding-right: 100px;
  
  
}

#HardwareGlobalLabel {
  /* position: absolute; */
  right: 200px;
  /* margin-top: 100px; */
  /* margin-bottom: 50px; */
  /* background-color:rgba(41, 241, 195, 1); */
  padding-right: 50px;
}

#HardwareGlobalSwitch {
  /* position: absolute; */
  right: 100px;
  /* margin-top: 200px; */
  /* margin-bottom: 50px; */
  /* background-color:rgba(41, 241, 195, 1); */
  /* top: 100px; */
  padding-right: 100px;
}

.emailDisableSoftwareSwitch {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: absolute;
  left: 500px;
  margin-top: 200px;
  margin-bottom: 20px;
  padding-right: 100px;
  
  
}

#SoftwareGlobalLabel {
  /* position: absolute; */
  right: 200px;
  /* margin-top: 100px; */
  /* margin-bottom: 50px; */
  /* background-color:rgba(41, 241, 195, 1); */
  padding-right: 50px;
}

#SoftwareGlobalSwitch {
  /* position: absolute; */
  right: 100px;
  /* margin-top: 200px; */
  /* margin-bottom: 50px; */
  /* background-color:rgba(41, 241, 195, 1); */
  /* top: 100px; */
  padding-right: 100px;
}

.emailDisableIndHardwareSwitch {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  /* flex-direction: row; */
  
}


.emailDisableIndSoftwareSwitch {
  display: flex;
  justify-content: flex-end;
  /* flex-direction: row; */
  
}

#HardwareEditButton:hover{
  color: rgb(65, 206, 173);
}

#EditHardwareLabel {
  display: flex;
  justify-content: flex-start;

}

#HardwareEditButton {
  right: 100px;
}

#HardwareTitle {
  padding-right: 10px;
}

#SoftwareEditButton:hover{
  color: rgb(65, 206, 173);
}

#EditSoftwareLabel {
  display: flex;
  justify-content: flex-start;

}

#SoftwareEditButton {
  right: 100px;
}

#SoftwareTitle {
  padding-right: 10px;
}

.clarifyTicketFormSubmitButton:disabled {
  background-color: #cccccc !important;
  border: 1px solid #999999 !important;
}

.containterClarifyTicketFormSubmitButton {
  text-align: center;
  margin-bottom: 15px;
}

.adminPrivateClarifyTIcketFormNote {
  padding-left: 15px;
  /* padding-top: 10px; */
}

#privacyNote {
  font-size: 14px;
}

/* admin private/public toggle */
.adminPrivatePublicSwitch {
  position: relative;
  display: inline-block;
  width: 90px;
  height: 34px;
  margin-left: auto;
  /* position: relative;
  display: inline-block;
  width: 90px;
  height: 34px;
  left: 820px; */
}

.adminPrivatePublicSwitch input {display:none;}

.adminTogPrivatePublicSlider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2ab934;
  transition: .4s;
  /* padding-right: 100px; */
  /* left: 10px; */
}

.adminTogPrivatePublicSlider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

input:checked + .adminTogPrivatePublicSlider {
  background-color: #ca2222;
}

input:focus + .adminTogPrivatePublicSlider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .adminTogPrivatePublicSlider:before {
  transform: translateX(55px);
}

.on
{
  display: none;
  right: -30%;
}

.on, .off
{
  color: white;
  position: absolute;
  transform: translate(-50%,-50%);
  top: 50%;
  left: 60%;
  font-size: 12px;
  /* font-family: Verdana, sans-serif; */
}

input:checked+ .adminTogPrivatePublicSlider .on
{display: block;}

input:checked + .adminTogPrivatePublicSlider .off
{display: none;}


/* Rounded sliders */
.adminTogPrivatePublicSlider.round {
  border-radius: 34px;
}

.adminTogPrivatePublicSlider.round:before {
  border-radius: 50%;}

.mantine-Select-dropdown {
  color: var(--mantine-color-text);
}

/* end admin private/public toggle */

.mantine-ChartTooltip-tooltip {
  min-width: calc(12.5rem* var(--mantine-scale));
  background-color: var(--mantine-color-body);
  box-shadow: var(--mantine-shadow-md);
  border-radius: var(--mantine-radius-default);
}

.mantine-ChartTooltip-tooltipLabel {
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-md);
  font-weight: 500;
  color: var(--mantine-color-bright);
}

.mantine-ChartTooltip-tooltipBody {
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  padding-top: 0;
}

.mantine-ChartTooltip-tooltipItem {
  font-size: var(--mantine-font-size-sm);
  display: flex;
  justify-content: space-between;
}

.mantine-ChartTooltip-tooltipItemBody {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-sm);
  margin-inline-end: var(--mantine-spacing-xl);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,4BAA4B;EAC5B;;2DAE4E;EAC5E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;;2DAE0E;EAC1E,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,sDAAsD;EACtD,gDAAgD;EAChD,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yDAAyD;EACzD,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;EAC9D,yDAAyD;AAC3D;;AAEA;EACE,2CAA2C;EAC3C,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;;GAEG;;AAEH;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;GAKG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,4EAA4E;EAC5E,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,6EAA6E;AAC/E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;uBACqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,gCAAgC,EAAE,mCAAmC;EACrE,eAAe,mBAAmB,qCAAqC;EACvE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,+CAA+C;AAC/C;EACE;AACF;;AAEA,+CAA+C;AAC/C;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,4BAA4B;EAC5B;wBACsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;uFAOuF;AACvF;;4BAE4B;AAC5B;;GAEG;;AAEH,kBAAkB;AAClB;;;;;GAKG;;AAEH,uDAAuD;AACvD;;;;;;GAMG;;AAEH;EACE,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;EAC5E,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;EAKE;;AAEF;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gDAAgD;EAChD,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;GAEG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,sDAAsD;EACtD,sDAAsD;EACtD,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;EACtD,sDAAsD;EACtD,iDAAiD;EACjD,sDAAsD;EACtD,sDAAsD;EACtD,iDAAiD;EACjD,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;;;AAGtB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;;;AAGtB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,4CAA4C;EAC5C,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;;AAE3B;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;;AAE3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;;AAE7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2BAA2B;;AAE7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;;;;gBAIc;AAChB;;AAEA,iCAAiC,YAAY,CAAC;;AAE9C;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EAEzB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,QAAQ;EACR,SAAS;EACT,eAAe;EACf,sCAAsC;AACxC;;AAEA;CACC,cAAc,CAAC;;AAEhB;CACC,aAAa,CAAC;;;AAGf,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,CAAC;;AAErB;EACE,gCAAgC;AAClC;;AAEA,oCAAoC;;AAEpC;EACE,8CAA8C;EAC9C,2CAA2C;EAC3C,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;AAC9C","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@font-face {\n  font-family: 'Gotham Narrow';\n  src: url('./fonts/GothamNarrow-Medium.woff2') format('woff2'),\n      url('./fonts/GothamNarrow-Medium.woff') format('woff'),\n      url('./fonts/GothamNarrow-Medium.svg#GothamNarrow-Medium') format('svg');\n  font-weight: 500;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Gotham Narrow';\n  src: url('./fonts/GothamNarrow-Light.woff2') format('woff2'),\n      url('./fonts/GothamNarrow-Light.woff') format('woff'),\n      url('./fonts/GothamNarrow-Light.svg#GothamNarrow-Light') format('svg');\n  font-weight: 300;\n  font-style: normal;\n  font-display: swap;\n}\n\n.addAssetButton {\n  background-color: rgba(75, 75, 75, 1) !important;\n  border-color: rgba(75, 75, 75, 1) !important;\n}\n\n.addAssetButton:hover {\n  /*background-color: rgba(41, 241, 195, 1) !important;*/\n  background-color: rgba(0, 76, 102, 1) !important;\n  /*border-color: rgba(41, 241, 195, 1) !important;*/\n  border-color: rgba(0, 76, 102, 1) !important;\n}\n\n.addFormPlusIcon:hover {\n  /*color: rgba(41, 241, 195, 1) !important;*/\n  color: rgba(0, 76, 102, 1) !important;\n}\n\n.addHardwareFormOuterWrapper {\n  height: 520px;\n  overflow: scroll;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.modal-content {\n  background-color: var(--mantine-color-default) !important;\n  color: var(--mantine-color-text);\n}\n\n.modal-button-group {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 200px;\n  margin-top: 20px;\n}\n\n.mantine-Modal-inner {\n  color: var(--mantine-color-text);\n}\n\n.mantine-Drawer-content {\n  color: var(--mantine-color-text);\n}\n\n.acceptedSolutionWrapper {\n  background-color: rgba(41, 241, 195, 0.10);\n  margin-top: 20px;\n}\n\n.accordianToggle {\n  cursor: pointer;\n}\n\n#activeForumHeader {\n  /*background-color: rgba(41, 241, 195, 1);*/\n  background-color: rgba(0, 76, 102, 1);\n  color: white;\n}\n\n#activeSideNavLink{\n  color: black;\n  font-weight: bold;\n}\n\n.activeSideNavLinkBox {\n  /*background-color: rgba(41, 241, 195, 1);*/\n  background-color: rgba(0, 76, 102, 1);\n}\n\n.activeMyAssignedTicketsHeader {\n  /* color: #38d9a9; */\n  color: #228be6;\n}\n\n.adminDashboardUserSearchBar {\n  width: 380px !important;\n}\n\n.adminDashboardUserSearchBar:hover {\n  background-color: rgba(0, 76, 102, 0.25) !important;\n}\n\n.adminDashboardHardwareAssetSearchBar {\n  width: 310px !important;\n}\n\n.adminDashboardHardwareAssetSearchBar:hover {\n  background-color: rgba(0, 76, 102, 0.25) !important;\n}\n\n.adminDashboardSoftwareAssetSearchBar {\n  width: 355px !important;\n}\n\n.adminDashboardSoftwareAssetSearchBar:hover {\n  background-color: rgba(0, 76, 102, 0.25) !important;\n}\n\n.addSoftwareAssignmentButtonContainer {\n  position: absolute;\n  left: 0;\n  padding-left: 10px;\n}\n\n.affectedDevicesDrawer {\n  offset: 8px !important;\n}\n\n.affectedDevicesHoverCardBackground {\n  /* background-color: var(--mantine-color-dark-4) !important; */\n  background-color: var(--mantine-color-default) !important;\n}\n\n.affectedDevicesHoverCardText {\n  color: var(--mantine-color-text) !important;\n  /* color: var(--mantine-color-gray-4) !important; */\n  cursor: default;\n}\n\n.assetFilterResetButtonContainer {\n  position: absolute;\n  left: 0;\n  padding-left: 10px;\n}\n\n#assetAssignmentsButton {\n  position: absolute;\n  top: 15%;\n  left: 15px;\n}\n\nbody {\n  background-color: #00000000 !important;\n}\n\n.cardHeader {\n  background-color: #12344d !important;\n}\n\n.clarifyFormButtonContainer {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n/* #clarifyFormReassignmentSelectorWrapper{\n  display: inline-block;\n  padding-top: 0px;\n} */\n\n.col-centered{\n  float: none;\n  margin: 0 auto;\n}\n\n.commentReplyingToTableRow {\n  border-top: none !important;\n}\n\n.commentReplyingToWrapper {\n  background-color: rgba(240, 248, 255, 1);\n}\n\n#downVotesText {\n  color: red;\n}\n\n.defaultCursor {\n  cursor: default;\n}\n\n.gothamNarrowFont {\n  font-family: 'Gotham Narrow';\n  font-weight: 500;\n  font-style: normal;\n}\n\n.gothamNarrowLightFont {\n  font-family: 'Gotham Narrow';\n  font-weight: 300;\n  font-style: normal;\n}\n\n.hardwareAssetFilterIcon:hover {\n  /*color: rgba(41, 241, 195, 1) !important;*/\n  color: rgba(0, 76, 102, 1) !important;\n}\n\n/* .hardwareAssetTableRow:hover {\n  background-color: pink !important;\n} */\n\n.hardwareAssetTable tbody tr:hover td {\n  background-color: rgba(0, 76, 102, 1);\n}\n\n.reportTable tbody tr:hover td {\n  background-color: rgba(0, 76, 102, 1);\n  color: white;\n  cursor: pointer;\n}\n\n#hardwareAssetEditDetailsButton {\n  position: absolute;\n  top: 15%;\n  right: 15px;\n  width: 110px;\n}\n\n.knowledgebaseButton:hover {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.landingPageInfoCard {\n  border: none !important;\n  /* background-color: whitesmoke !important; */\n  background-color: rgba(211,211,211, 1) !important;\n}\n\n#landingPageLoginButton {\n  color: black !important;\n  font-size: 15pt;\n}\n\n#landingPageLoginButtonContainer {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  padding-top: 25px;\n  padding-right: 45px;\n}\n\n#landingPageWelcomeMessage {\n  position: absolute;\n  float: left;\n  left: 0px;\n  top: 0px;\n  color: white;\n  font-family: 'Gotham Narrow';\n  font-style: normal;\n  font-weight: 500;\n  padding-top: 25px;\n  padding-left: 15px;\n}\n\n/* #logoWhiteCircle {\n  border-radius: 50%;\n  width: 38px;\n  height: 38px;\n  background-color: white;\n} */\n\n.myTicketTableText {\n  text-align: left;\n}\n\n.myTicketTableRow:hover {\n  /* background-color: rgba(0, 76, 102, 1); */\n  background-color: rgba(52, 92, 124, 1);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  /*color:rgba(41, 241, 195, 1);*/\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.popular-activities-table-row:hover {\n  background-color: rgba(52, 92, 124, 1);\n  /* background-color: rgba(0, 76, 102, 1); */\n  box-shadow: 0 4px 28px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.popular-activities-link-text {\n  color: rgba(75, 75, 75, 1);\n}\n\n.popular-activities-link-text:hover {\n  /*color: rgba(41, 241, 195, 1);*/\n  color: white;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.replyButtonTableRow {\n  border-top-style: none !important;\n}\n\n.requiredStar {\n  color:red;\n  padding-left: 2px;\n}\n\n.miniKnowledgebaseWrapper {\n  background-color: #edeef3;\n  position: absolute;\n  right: 30px;\n  width: 325px;\n  /* height: 83vh;\n  overflow-y: scroll; */\n}\n\n.miniKnowledgebase {\n  /* background-color: darkred; */\n  /* position: relative; */\n  margin-left: auto;\n}\n\n.miniKnowledgebaseIssuePreview {\n  color:gray;\n  font-size: 10pt !important;\n}\n\n.miniKnowledgebaseTable {\n  max-width: 100%;\n  max-height: 100%;\n}\n\ntd .removeAssignmentButtonWrapper {\n  position: absolute;\n  right: 0;\n  margin-right: 30px;\n  opacity: 0;\n  transition: opacity .2s ease-out; /* adding transition, improved UI */\n  cursor: pointer;                  /* change cursor when hovering icon */\n  transition-delay: .1s;\n}\n\ntd:hover .removeAssignmentButtonWrapper {\n  position: absolute;\n  right: 0;\n  margin-right: 30px;\n  opacity: 1;\n  transition-delay: 0s;\n  /* padding-right: 30px; */\n}\n\n.mantine-DateInput-calendarHeader {\n  color: var(--mantine-color-text)\n}\n\n.mantine-DateTimePicker-calendarHeader {\n  color: var(--mantine-color-text)\n}\n\n.mantine-DatePickerInput-calendarHeader {\n  color: var(--mantine-color-text)\n}\n\n.mantine-Select-dropdown {\n  position: relative;\n  z-index: 5000;\n}\n\n.mantineBlue {\n  color: var(--mantine-color-blue-text);\n  font-size: var(--mantine-font-size-sm);\n}\n\n/* Used in the user profile permissions table */\n.roleYesText {\n  color: var(--mantine-color-blue-8)\n}\n\n/* Used in the user profile permissions table */\n.roleNoText {\n  color: var(--mantine-color-red-8)\n}\n\n#serverRoomImageContainer {\n  max-width: 100%;\n  position: relative;\n}\n\n.scrollTableWrapper{\n  height: 500px;\n  overflow: scroll;\n}\n\n.scrollTableWrapperAssignedTickets{\n  height: 451px;\n  overflow-y: scroll;\n}\n\n.scrollTableWrapperTechNotes{\n  max-height: 260px;\n  overflow: scroll;\n}\n\n/* #selectAssignedTechDropdownButton{\n  color: pink;\n} */\n\n.selectAssignedTechDropdownTriangleIcon{\n  padding-left: 3px;\n  font-size: 13px;\n}\n\n.smallCumulusLogoContainer {\n  position: absolute;\n  top: 125px;\n  padding-right: 150px;\n  margin-left: 300px;\n  /* background-color: aqua; */\n  /* padding-top: 25px;\n  padding-right: 45px; */\n}\n\n.suggestedPostsTitle {\n  text-align: center;\n}\n\n/* .sidebarContainer {\n  margin: 40px 0 0 0;\n  padding: 0;\n  width: 200px;\n  background-color: #343a40;\n  position: fixed;\n  height: 100%;\n  overflow: auto; /*affects whether there's a scroll bar or not may need \"scroll\" here*/\n/*}\n\n/* Sidebar link first item */\n/* .sidebarNav:first-child {\n  padding-top: 0px;\n} */\n\n/* Sidebar links */\n/* .sideNavItem {\n  display: block;\n  color: black;\n  padding: 5px;\n  text-decoration: none;\n} */\n\n/* Sidebar link (text part) - override the Link class */\n/* .sideNavLink {\n  color: rgba(255,255,255,.5);\n}\n\n.sideNavLink:hover {\n  color: rgba(41, 241, 195, 1);\n} */\n\n.ticketLandingCard {\n  color: rgba(75, 75, 75, 1);\n}\n\n.ticketLandingCard:hover {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  color: rgba(203, 51, 59, 1);\n}\n\n.ticketLandingLink:hover {\n  text-decoration: none;\n}\n\n/*.ticketTableBody > tr:hover {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  cursor: pointer;\n  background-color: rgba(41, 241, 195, 0.2);\n  \n}*/\n\n.techNoteTableHead > th {\n  background-color: rgba(75, 75, 75, 1);\n  color: white;\n}\n\n.techNoteTableHead >th:hover {\n  cursor: default;\n}\n\n.ticketTableHead > th {\n  background-color: rgba(75, 75, 75, 1);\n  color: white;\n}\n\n.ticketTableHead > th:hover {\n  /*background-color:rgba(41, 241, 195, 1);*/\n  background-color: rgba(0, 76, 102, 1);\n  color: white;\n  cursor: pointer;\n}\n\n#reactQuillBoxDisabled {\n  cursor: default !important;\n  background-color: lightgray !important;\n}\n\n#createTicketIssueText {\n  background-color: white !important;\n}\n\n.ql-editor{\n  min-height: 120px;\n  font-size: 15px;\n}\n\n.reportTableHead > th {\n  background-color: rgba(75, 75, 75, 1);\n  color: white;\n  cursor: default;\n}\n\n.submitterDetailsIcon {\n  color: var(--mantine-color-blue-8);\n}\n\n.ticketTableHeadNoHover:hover {\n  background-color: rgba(75, 75, 75, 1) !important;\n  color: white !important;\n  cursor: default !important;\n}\n\n.ticketCategoryName {\n  /* color:rgba(68, 108, 179, 1); */\n  color: rgba(75, 75, 75, 1);\n}\n\n.ticketTitleText {\n  font-size: 20px;\n  /* color: rgba(75, 75, 75, 1); */\n  /* text-decoration: underline; */\n}\n\n/* .ticketTitleText:hover {\n  color:rgba(41, 241, 195, 1);\n} */\n\n.ticketIssuePreview {\n  color:gray;\n}\n\n.topNavbarLink {\n  color: var(--mantine-color-text) !important;\n  line-height: 66px;\n}\n\n.topNavbarLink:hover {\n  /*color:rgba(41, 241, 195, 1) !important;*/\n  /* color: rgba(0, 76, 102, 1) !important; */\n  color: rgba(52, 92, 124, 1) !important;\n  cursor: pointer;\n}\n\n#ticketForumPageHeader {\n  text-align: center;\n  margin-top: 15px;\n  margin-bottom: 30px;\n}\n\n#ticketDateText {\n  font-size: 13px;\n  text-align: left;\n}\n\n#ticketRequesterText {\n  font-size: 13px;\n}\n\n#ticketViews {\n  text-align: left;\n}\n\n#thumbImage {\n  height: 15px;\n  width: 15px;\n}\n\n#upVotesText {\n  color: green;\n}\n\n.wholeCard {\n  border-radius: 50px !important;\n}\n\n.nav-tabs .nav-link {\n  color: white;\n}\n\n.nav-tabs .nav-link:hover {\n  /*color: rgba(41, 241, 195, 1);*/\n  /* color: rgba(0, 76, 102, 1); */\n  color: rgba(52, 92, 124, 1);\n  /*border: 1px solid rgba(41, 241, 195, 1) !important;*/\n  /* border: 1px solid rgba(0, 76, 102, 1) !important; */\n  border: 1px solid rgba(52, 92, 124, 1) !important;\n}\n\n.nav-tabs .nav-link.active {\n  /*background-color: rgba(41, 241, 195, 1) !important;*/\n  /* background-color: rgba(0, 76, 102, 1) !important; */\n  background-color: rgba(52, 92, 124, 1) !important;\n  /*border: 1px solid rgba(41, 241, 195, 1) !important;*/\n  /* border: 1px solid rgba(0, 76, 102, 1) !important; */\n  border: 1px solid rgba(52, 92, 124, 1) !important;\n  font-weight: bold;\n  color: white !important;\n}\n\n.emailDisableHardwareSwitch {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  position: absolute;\n  left: 500px;\n  margin-top: 100px;\n  margin-bottom: 20px;\n  padding-right: 100px;\n  \n  \n}\n\n#HardwareGlobalLabel {\n  /* position: absolute; */\n  right: 200px;\n  /* margin-top: 100px; */\n  /* margin-bottom: 50px; */\n  /* background-color:rgba(41, 241, 195, 1); */\n  padding-right: 50px;\n}\n\n#HardwareGlobalSwitch {\n  /* position: absolute; */\n  right: 100px;\n  /* margin-top: 200px; */\n  /* margin-bottom: 50px; */\n  /* background-color:rgba(41, 241, 195, 1); */\n  /* top: 100px; */\n  padding-right: 100px;\n}\n\n.emailDisableSoftwareSwitch {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  position: absolute;\n  left: 500px;\n  margin-top: 200px;\n  margin-bottom: 20px;\n  padding-right: 100px;\n  \n  \n}\n\n#SoftwareGlobalLabel {\n  /* position: absolute; */\n  right: 200px;\n  /* margin-top: 100px; */\n  /* margin-bottom: 50px; */\n  /* background-color:rgba(41, 241, 195, 1); */\n  padding-right: 50px;\n}\n\n#SoftwareGlobalSwitch {\n  /* position: absolute; */\n  right: 100px;\n  /* margin-top: 200px; */\n  /* margin-bottom: 50px; */\n  /* background-color:rgba(41, 241, 195, 1); */\n  /* top: 100px; */\n  padding-right: 100px;\n}\n\n.emailDisableIndHardwareSwitch {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  /* flex-direction: row; */\n  \n}\n\n\n.emailDisableIndSoftwareSwitch {\n  display: flex;\n  justify-content: flex-end;\n  /* flex-direction: row; */\n  \n}\n\n#HardwareEditButton:hover{\n  color: rgb(65, 206, 173);\n}\n\n#EditHardwareLabel {\n  display: flex;\n  justify-content: flex-start;\n\n}\n\n#HardwareEditButton {\n  right: 100px;\n}\n\n#HardwareTitle {\n  padding-right: 10px;\n}\n\n#SoftwareEditButton:hover{\n  color: rgb(65, 206, 173);\n}\n\n#EditSoftwareLabel {\n  display: flex;\n  justify-content: flex-start;\n\n}\n\n#SoftwareEditButton {\n  right: 100px;\n}\n\n#SoftwareTitle {\n  padding-right: 10px;\n}\n\n.clarifyTicketFormSubmitButton:disabled {\n  background-color: #cccccc !important;\n  border: 1px solid #999999 !important;\n}\n\n.containterClarifyTicketFormSubmitButton {\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.adminPrivateClarifyTIcketFormNote {\n  padding-left: 15px;\n  /* padding-top: 10px; */\n}\n\n#privacyNote {\n  font-size: 14px;\n}\n\n/* admin private/public toggle */\n.adminPrivatePublicSwitch {\n  position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 34px;\n  margin-left: auto;\n  /* position: relative;\n  display: inline-block;\n  width: 90px;\n  height: 34px;\n  left: 820px; */\n}\n\n.adminPrivatePublicSwitch input {display:none;}\n\n.adminTogPrivatePublicSlider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #2ab934;\n  -webkit-transition: .4s;\n  transition: .4s;\n  /* padding-right: 100px; */\n  /* left: 10px; */\n}\n\n.adminTogPrivatePublicSlider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .adminTogPrivatePublicSlider {\n  background-color: #ca2222;\n}\n\ninput:focus + .adminTogPrivatePublicSlider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .adminTogPrivatePublicSlider:before {\n  -webkit-transform: translateX(55px);\n  -ms-transform: translateX(55px);\n  transform: translateX(55px);\n}\n\n.on\n{\n  display: none;\n  right: -30%;\n}\n\n.on, .off\n{\n  color: white;\n  position: absolute;\n  transform: translate(-50%,-50%);\n  top: 50%;\n  left: 60%;\n  font-size: 12px;\n  /* font-family: Verdana, sans-serif; */\n}\n\ninput:checked+ .adminTogPrivatePublicSlider .on\n{display: block;}\n\ninput:checked + .adminTogPrivatePublicSlider .off\n{display: none;}\n\n\n/* Rounded sliders */\n.adminTogPrivatePublicSlider.round {\n  border-radius: 34px;\n}\n\n.adminTogPrivatePublicSlider.round:before {\n  border-radius: 50%;}\n\n.mantine-Select-dropdown {\n  color: var(--mantine-color-text);\n}\n\n/* end admin private/public toggle */\n\n.mantine-ChartTooltip-tooltip {\n  min-width: calc(12.5rem* var(--mantine-scale));\n  background-color: var(--mantine-color-body);\n  box-shadow: var(--mantine-shadow-md);\n  border-radius: var(--mantine-radius-default);\n}\n\n.mantine-ChartTooltip-tooltipLabel {\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);\n  font-size: var(--mantine-font-size-md);\n  font-weight: 500;\n  color: var(--mantine-color-bright);\n}\n\n.mantine-ChartTooltip-tooltipBody {\n  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);\n  padding-top: 0;\n}\n\n.mantine-ChartTooltip-tooltipItem {\n  font-size: var(--mantine-font-size-sm);\n  display: flex;\n  justify-content: space-between;\n}\n\n.mantine-ChartTooltip-tooltipItemBody {\n  display: flex;\n  align-items: center;\n  gap: var(--mantine-spacing-sm);\n  margin-inline-end: var(--mantine-spacing-xl);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
